import apiService from '../utils/apiService';

import {
  GET_SIGNET_EXAMPLE_LIST_PAGEABLE,
  GET_SIGNET_EXAMPLE_LIST_START,
  GET_SIGNET_EXAMPLE_LIST_ERROR,
  ADD_SIGNET_EXAMPLE,
  ADD_SIGNET_EXAMPLE_START,
  ADD_SIGNET_EXAMPLE_ERROR,
  DOWNLOAD_EXAMPLE_SIGNET_START,
  DOWNLOAD_EXAMPLE_SIGNET_ERROR,
} from './types';

import {
  signetExampleUploadPath,
  signetExampleDownloadPath,
  signetExampleFindAllPageablePath,
} from '../constants/apiEndpoints';

import {
  notificationTypeSuccess,
  notificationTypeError,
} from '../constants/globals';
import { createNotification } from '../utils';

const addSignetExampleStart = () => {
  return {
    type: ADD_SIGNET_EXAMPLE_START,
  };
};
const addSignetExampleSuccessfully = (data) => {
  return {
    type: ADD_SIGNET_EXAMPLE,
    payload: data,
  };
};
const addSignetExampleUnsuccessfully = (err) => {
  return {
    type: ADD_SIGNET_EXAMPLE_ERROR,
    payload: err,
  };
};

const getSignetExampleListStart = () => {
  return {
    type: GET_SIGNET_EXAMPLE_LIST_START,
  };
};

const getSignetExampleListUnsuccessfully = (err) => {
  return {
    type: GET_SIGNET_EXAMPLE_LIST_ERROR,
    payload: err,
  };
};

const getSignetExampleListPageableSuccessfully = (
  data,
  pageNumber,
  totalElements
) => {
  return {
    type: GET_SIGNET_EXAMPLE_LIST_PAGEABLE,
    payload: [data, pageNumber, totalElements],
  };
};

const downloadSignetExampleStart = () => {
  return {
    type: DOWNLOAD_EXAMPLE_SIGNET_START,
  };
};

const downloadSignetExampleSuccessfully = (data, documentName, message) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', documentName);
  document.body.appendChild(link);
  link.click();
  URL.revokeObjectURL(url);
  createNotification(
    notificationTypeSuccess,
    message.signet,
    message.successDownloadExample
  );
};

const downloadSignetExampleUnsuccessfully = (err) => {
  return {
    type: DOWNLOAD_EXAMPLE_SIGNET_ERROR,
    payload: err,
  };
};

export const uploadSignetExample = (
  fileData,
  callback,
  NotificationMessages
) => {
  return (dispatch) => {
    dispatch(addSignetExampleStart());
    return apiService
      .post(signetExampleUploadPath(), fileData)
      .then((response) => {
        dispatch(addSignetExampleSuccessfully(response.data));
        callback();
      })
      .catch((err) => {
        dispatch(addSignetExampleUnsuccessfully(err?.response?.data));
        createNotification(
          notificationTypeError,
          NotificationMessages.signetExample,
          err?.response?.data?.message
        );
      });
  };
};

export const findAllSignetExampleListPageable = (pageNumber, pageSize) => {
  return (dispatch) => {
    dispatch(getSignetExampleListStart());
    return apiService
      .get(signetExampleFindAllPageablePath(pageNumber, pageSize))
      .then((response) => {
        dispatch(
          getSignetExampleListPageableSuccessfully(
            response.data.content,
            response.data.totalPages,
            response.data.totalElements
          )
        );
      })
      .catch((err) => {
        dispatch(getSignetExampleListUnsuccessfully(err?.response?.data));
      });
  };
};

export const downloadExample = (message) => async (dispatch) => {
  dispatch(downloadSignetExampleStart());
  return apiService
    .getFromFile(signetExampleDownloadPath())
    .then((response) => {
      dispatch(
        downloadSignetExampleSuccessfully(
          response.data,
          'Спољни приказ електронског печата.docx',
          message
        )
      );
    })
    .catch((err) => {
      dispatch(downloadSignetExampleUnsuccessfully(err?.response?.data));
      if (err?.response?.status === 500) {
        createNotification(
          notificationTypeError,
          message.signet,
          message.unsuccessfulDownload
        );
      }
    });
};
